import Apiservices from '../../lib/ApiServices'
import ApisMethods from './apisMethods'

const ProductsCata = {
  add: async (data: any, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/products`, data, callback, setIsLoading)
  },
}
export default ProductsCata
